import React, { FunctionComponent } from 'react';
import { Route, Routes } from 'react-router-dom';
import { PageFrame } from './components/PageFrame';
import { VideoSharePage } from './pages/VideoSharePage';

// The site does exactly one thing: resolve a share short code from the URL path and play its videos. The short code is
// the entire path, e.g. https://<host>/AbC123. Any other path shows the "no code" message.
export const App: FunctionComponent = () => (
  <Routes>
    <Route path="/:shortCode" element={<VideoSharePage />} />
    <Route
      path="*"
      element={
        <PageFrame>
          <p className="text-on-background/70 text-center text-lg">
            No share code was provided. Open the link exactly as it was shared with you.
          </p>
        </PageFrame>
      }
    />
  </Routes>
);
